module dm.portal.services {

    angular.module("dm.portal.services")
        .service("dm.portal.services.usersService", [
            "$q",
            "dm.portal.services.usersClient",
            ($q, usersClient) =>
                new UsersService($q, usersClient)]);

    export interface IUsersService {
        login: (username: string, password: string) => ng.IPromise<any>;
        resetPassword: (username: string) => ng.IPromise<{}>;
        getCurrentUser: () => ng.IPromise<ICurrentUserDTO>;
        changePassword: (oldPassword: string, newPassword: string) => ng.IPromise<boolean>;
        setCmcCookies: () => ng.IPromise<void>;
        updateUser: (user: IUserDTO) => ng.IPromise<IUserDTO>;
        getUsersByCompany: (legacyCompanyId: string) => ng.IPromise<IUserDTO[]>;
        getUsersAssignableToWorkflow: (legacyCompanyId: string) => ng.IPromise<IUserDTO[]>;
        getUsersByProject: (projectId: number) => ng.IPromise<IUserDTO[]>;
        getUsersByReport: (reportId: number) => ng.IPromise<IUserDTO[]>;
        getNetSuiteCustomerId: () => ng.IPromise<string>;
        getNetSuiteCaseId: (caseNumber: string) => ng.IPromise<string>;
    }

    export class UsersService implements IUsersService {
        private currentUserPromise: ng.IPromise<ICurrentUserDTO> = null;

        constructor(
            private $q: ng.IQService,
            private usersClient: IUsersClient) {
        }

        login = (username: string, password: string): ng.IPromise<any> => {
            var loginDef = this.$q.defer();

            this.usersClient.login(username, password)
                .then((response) => {
                    loginDef.resolve();
                }, (failedResponse) => {
                    switch (failedResponse.status) {
                        case 401:
                            loginDef.reject("The User Name or Password you entered is not valid. Please enter a valid User Name and Password and try again.");
                            break;
                        case 428: //change password required
                            var rejectReason = { status: 428, reason: failedResponse.data}
                            loginDef.reject(rejectReason);
                            break;
                        default:
                            loginDef.reject("Internal server error");
                            break;
                    }
                });

            return loginDef.promise;
        }

        resetPassword = (username: string): ng.IPromise<{}> => {
            return this.usersClient.resetPassword(username)
                .then(response => response.data);
        }

        getCurrentUser = (): ng.IPromise<ICurrentUserDTO> => {
            // Lazy load and cache current user
            if (this.currentUserPromise === null) {
                this.currentUserPromise = this.usersClient.getCurrentUser().then((response) => {
                    return response.data;
                });
            }

            return this.currentUserPromise;
        }

        changePassword = (oldPassword: string, newPassword: string): ng.IPromise<boolean> => {
            return this.usersClient.changePassword(oldPassword, newPassword).then((response) => {
                return response.data;
            });
        }

        setCmcCookies = (): ng.IPromise<void> => {
            return this.usersClient.setCmcCookies().then(angular.noop);
        }

        updateUser = (user: IUserDTO): ng.IPromise<IUserDTO> => {
            return this.usersClient.updateUser(user).then(response => {
                // Invalidate the current user promise
                this.currentUserPromise = null;
                return response.data;
            });
        }

        getUsersByCompany = (legacyCompanyId: string): ng.IPromise<IUserDTO[]> => {
            return this.usersClient.getUsersByCompany(legacyCompanyId).then(response => response.data);
        }

        getUsersAssignableToWorkflow = (legacyCompanyId: string): ng.IPromise<IUserDTO[]> => {
            return this.usersClient.getUsersAssignableToWorkflow(legacyCompanyId).then(response => response.data);
        }

        getUsersByProject = (projectId: number): ng.IPromise<IUserDTO[]> => {
            return this.usersClient.getUsersByProject(projectId).then(response => response.data);
        }

        getUsersByReport = (reportId: number): ng.IPromise<IUserDTO[]> => {
            return this.usersClient.getUsersByReport(reportId).then(response => response.data);
        }

        getNetSuiteCustomerId = (): ng.IPromise<string> => {
            return this.usersClient.getNetSuiteCustomerId().then(response => response.data);
        }

        getNetSuiteCaseId = (caseNumber: string): ng.IPromise<string> => {
            return this.usersClient.getNetSuiteCaseId(caseNumber).then(response => response.data);
        }
    }
}